import { render, staticRenderFns } from "./PhotosCombined.vue?vue&type=template&id=b0a243be&scoped=true&"
import script from "./PhotosCombined.vue?vue&type=script&lang=js&"
export * from "./PhotosCombined.vue?vue&type=script&lang=js&"
import style0 from "./PhotosCombined.vue?vue&type=style&index=0&id=b0a243be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a243be",
  null
  
)

export default component.exports